import { useQuery } from "@tanstack/react-query";
import React from "react";
import Button from "../UI/Button";
import { API_IMPORT_ALL_KITE_EXCHANGE } from "../../utils/api/ApiConstant";
import { getAxios } from "../../Services/commonService";
import showToast from "../../utils/toastUtil";

const ImportExchange = () => {
  const { isLoading, refetch } = useQuery({
    queryKey: ["importData"],
    queryFn: async () => {
      const res = await getAxios({
        url: API_IMPORT_ALL_KITE_EXCHANGE,
        params: {},
      });
      showToast.success(res?.message);
    },
    enabled: false,
  });

  return (
    <div className="card_bod">
      <h1 className="m-1">Import All Kite Exchange</h1>
      <div className="btn_box">
        <Button
          className={"btn-primary"}
          onClick={() => refetch()}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "ADD"}
        </Button>
        <Button className={"btn-danger"}>Cancel</Button>
      </div>
    </div>
  );
};

export default ImportExchange;
